import type { UserProfile } from '../types/user';

const isFilled = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  if (value === null || value === undefined) {
    return false;
  }
  return Boolean(value);
};

export const isOnboardingComplete = (profile: UserProfile | null | undefined): boolean => {
  if (!profile) {
    console.log('Onboarding check: No profile available');
    return false;
  }

  // Check each field individually for better debugging
  const checks = {
    current_role: isFilled(profile.current_role),
    years_of_experience: isFilled(profile.years_of_experience),
    industry: isFilled(profile.industry),
    goal_statement: isFilled(profile.goal_statement),
    support_need: isFilled(profile.support_need),
    preferred_coach: isFilled(profile.preferred_coach),
    recommended_coach: isFilled(profile.recommended_coach)
  };

  // Log the status of each field
  console.log('Onboarding completion check:', checks);

  // For both development and production, check if all required fields are filled
  const isComplete = Boolean(
    checks.current_role &&
    checks.years_of_experience &&
    checks.industry &&
    checks.goal_statement &&
    checks.support_need &&
    checks.preferred_coach &&
    checks.recommended_coach
  );

  console.log('Onboarding complete:', isComplete);
  return isComplete;
};
